var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 4.39655H4.39655V7.11207H3.31034V4.39655Z",
    fill: "#414042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 16.8879H4.39655V19.6034H3.31034V16.8879Z",
    fill: "#414042"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6034 16.8879H20.6897V19.6034H19.6034V16.8879Z",
    fill: "#414042"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6034 10.3707H20.6897V13.6293H19.6034V10.3707Z",
    fill: "#414042"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 10.3707H4.39655V13.6293H3.31034V10.3707Z",
    fill: "#414042"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82759 3.31034H14.1724V4.39655H9.82759V3.31034Z",
    fill: "#414042"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82759 19.6034H14.1724V20.6897H9.82759V19.6034Z",
    fill: "#414042"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6034 4.39655H20.6897V7.11207H19.6034V4.39655Z",
    fill: "#414042"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 3.31034H7.11207V4.39655H3.31034V3.31034Z",
    fill: "#414042"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31034 19.6034H7.11207V20.6897H3.31034V19.6034Z",
    fill: "#414042"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8879 19.6034H20.6897V20.6897H16.8879V19.6034Z",
    fill: "#414042"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8879 3.31034H20.6897V4.39655H16.8879V3.31034Z",
    fill: "#414042"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1.65517V24H0V0Z",
    fill: "#414042"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3448 0H24V24H22.3448V0Z",
    fill: "#414042"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 0H22.3448V1.65517H1.65517V0Z",
    fill: "#414042"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65517 22.3448H22.3448V24H1.65517V22.3448Z",
    fill: "#414042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegion);
export default __webpack_public_path__ + "static/media/Region.f57bdc9571ef73bc6e30bed06f96513a.svg";
export { ForwardRef as ReactComponent };